<template>
  <div class="mb-4 d-flex flex-column">
    <radio-filter
      @change="value => handleChange(filterType.LANGUAGE, value)"
      title="Язык"
      :disabled="filters[filterType.NATIONALITY]?.length > 0"
      :options="languageOptions"
      :value="filters[filterType.LANGUAGE]"
    />
    <select-filter
      @change="value => handleChange(filterType.TARIFFS, value)"
      title="Тарифы"
      :disabled="isUserIdsFilterActive"
      :options="tariffOptions"
      :value="filters[filterType.TARIFFS]"
    />
    <select-filter
      @change="value => handleChange(filterType.PAYOUT_TYPE, value)"
      title="Способ выплаты"
      :disabled="isUserIdsFilterActive"
      :options="payoutTypeOptions"
      :value="filters[filterType.PAYOUT_TYPE]"
    />
    <select-filter
      @change="value => handleChange(filterType.PREFERRED_APPLICATIONS, value)"
      title="Приложение"
      :disabled="isUserIdsFilterActive"
      :options="preferredApplicationsOptions"
      :value="filters[filterType.PREFERRED_APPLICATIONS]"
    />
    <autocomplete-filter
      @change="value => handleChange(filterType.NATIONALITY, value)"
      title="Гражданство"
      :disabled="!!filters[filterType.LANGUAGE] || isUserIdsFilterActive"
      :options="nationalityOptions"
      :value="filters[filterType.NATIONALITY]"
    />
    <autocomplete-filter
      @change="value => handleChange(filterType.CITY, value)"
      title="Город"
      :disabled="isUserIdsFilterActive"
      :options="cityOptions"
      :value="filters[filterType.CITY]"
    />
    <radio-filter
      @change="value => handleChange(filterType.IS_MANDATE_CONTRACT, value)"
      title="Umowa zlecenia"
      :disabled="isUserIdsFilterActive"
      :options="booleanOptions"
      :value="filters[filterType.IS_MANDATE_CONTRACT]"
    />
    <select-filter
      @change="value => handleChange(filterType.MANDATE_CONTRACT_TYPE, value)"
      title="Umowa zlecenia Тип"
      :disabled="isUserIdsFilterActive"
      :options="mandateContractTypeOptions"
      :value="filters[filterType.MANDATE_CONTRACT_TYPE]"
    />
    <select-filter
      @change="value => handleChange(filterType.MANDATE_CONTRACT_TIME, value)"
      title="Umowa zlecenia Etat"
      :disabled="isUserIdsFilterActive"
      :options="mandateContractTimeOptions"
      :value="filters[filterType.MANDATE_CONTRACT_TIME]"
    />
    <v-file-input
      accept="text/csv"
      :label="
        filters[filterType.USER_IDS]?.length
          ? userIdsCsvOriginalFileName
          : 'Добавьте csv файл с user ids'
      "
      @change="value => handleChange(filterType.USER_IDS_CSV, value)"
      :value="filters[filterType.USER_IDS_CSV]"
    />
    <v-btn
      @click="$emit('resetFilters')"
      class="mt-4"
      small
      text
      color="primary"
    >
      Почистити фільтри
    </v-btn>
  </div>
</template>

<script>
import RadioFilter from './filters/RadioFilter.vue';
import SelectFilter from './filters/SelectFilter.vue';
import AutocompleteFilter from './filters/AutocompleteFilter.vue';
import { BULK_MESSAGES_FILTER_TYPE, COUNTRIES, CITIES } from './constants';
import { TARIFF_ID, TARIFF_TRANSLATION } from '../../../../models/finex';

export default {
  name: 'BulkMessagesFilters',
  components: {
    RadioFilter,
    SelectFilter,
    AutocompleteFilter,
  },

  props: {
    filters: Object,
    userIdsCsvOriginalFileName: String,
  },

  data() {
    return {
      filterType: BULK_MESSAGES_FILTER_TYPE,
      languageOptions: [
        { label: 'Английский', value: 'en' },
        { label: 'Узбецкий', value: 'uzb' },
        { label: 'Польский', value: 'pl' },
        { label: 'Русский', value: 'ru' },
      ],
      payoutTypeOptions: [
        { text: 'Наличные', value: 'cash' },
        { text: 'Банковский счет', value: 'bankAccount' },
      ],
      preferredApplicationsOptions: [
        { text: 'Uber Driver', value: 'uber' },
        { text: 'Uber Eats', value: 'uberEats' },
        { text: 'Bolt Driver', value: 'bolt' },
        { text: 'Bolt Food', value: 'boltFood' },
        { text: 'FreeNow', value: 'freeNow' },
        { text: 'Bliq', value: 'bliq' },
        { text: 'Glovo', value: 'glovo' },
        { text: 'Wolt', value: 'wolt' },
        { text: 'Stuart', value: 'stuart' },
      ],
      nationalityOptions: COUNTRIES.map(country => ({
        text: country,
        value: country,
      })),
      cityOptions: CITIES.map(city => ({
        text: city,
        value: city,
      })),
      mandateContractTypeOptions: [
        { text: 'Taxi', value: 'taxi' },
        { text: 'Delivery', value: 'delivery' },
      ],
      mandateContractTimeOptions: [
        { text: 'Full', value: 1 },
        { text: '1/4', value: 0.25 },
        { text: '1/8', value: 0.125 },
      ],
      booleanOptions: [
        { label: 'Да', value: true },
        { label: 'Нет', value: false },
      ],
      tariffOptions: Object.values(TARIFF_ID).map(tariffId => ({
        text: TARIFF_TRANSLATION[tariffId],
        value: tariffId,
      })),
    };
  },

  computed: {
    isUserIdsFilterActive() {
      return !!(
        this.filters[this.filterType.USER_IDS]?.length ||
        this.filters[this.filterType.USER_IDS_CSV]
      );
    },
  },

  methods: {
    handleChange(key, value) {
      this.$emit('change', key, value);
    },
  },
};
</script>
